export interface ShortcutGroupToShortcuts {
    shortcutGroup: ShortcutGroup;
    shortcuts: Shortcut[];
};

export interface ShortcutGroup {
    name: string;
    id: string;
};

export interface Shortcut extends ShortcutBase {
    id: string;
};

export interface ShortcutBase {
    name: string;
    audiences: string[];
    isEnabled: boolean;
    url: string;
    openInNewWindow: boolean;
};

export interface ShortcutUpdateModelv1 extends ShortcutBase {
    groupId?: string;
    id?: string;
};

export interface ShortcutsState {
    filteredShortcutFormat: ShortcutGroupToShortcuts[];
    originalShortcutFormat: ShortcutGroupToShortcuts[];
    shortcutFeed: ShortcutGroupToShortcuts[];
    isLoadingOriginalShortcutFormat: boolean;
    isFetching: boolean;
    isUpdating: boolean;
    successMessage?: string;
    errorMessage?: string;
    scrollToRowId?: string;
};

export interface ShortcutsFilterv1 {
    state: ShortcutState[];
    audiences: string[];
    searchText: string;
};

export const defaultShortcutsFilter: ShortcutsFilterv1 = {
    audiences: [],
    searchText: "",
    state: [],
};

export const defaultShortcut: ShortcutUpdateModelv1 = {
    name: "",
    audiences: [],
    isEnabled: true,
    url: "",
    openInNewWindow: true,
    groupId: ""
};

export interface FlattenedShorcut {
    id: string,
    isGroup: boolean,
    name: string,
    audiences?: string[];
    isEnabled?: boolean;
    url?: string;
    openInNewWindow?: boolean;
};

export enum ShortcutState {
    ENABLED = "Enabled",
    DISABLED = "Disabled"
};

export const allShortcutStates: ShortcutState[] = [ShortcutState.ENABLED, ShortcutState.DISABLED];

export enum ShortcutAction {
    EDIT,
    MOVE,
    ENABLE,
    DISABLE,
    DELETE
};

export enum ShortcutGroupAction {
    EDIT,
    ADD_SHORTCUT,
    ENABLE_ALL,
    DISABLE_ALL,
    DELETE
};

export const MAX_SHORTCUT_NAME_LENGTH = 50;

export const MAX_SHORTCUT_GROUP_NAME_LENGTH = 100;

export interface HeaderCell {
    id: string;
    label: string;
};

export const SHORTCUTS_HEADER_CELLS: HeaderCell[] = [
    { id: "name", label: "Shortcut Name" },
    { id: "kebab", label: "" },
    { id: "state", label: "State" },
    { id: "audiences", label: "Audiences" },
    { id: "url", label: "URL" },
    { id: "openIn", label: "Open In" }
];